import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AccessDisableDirective, AccessVisibilityDirective } from './access.directive';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
    ],
    declarations: [
        AccessVisibilityDirective,
        AccessDisableDirective
    ],
    exports: [
        AccessVisibilityDirective,
        AccessDisableDirective
    ]
})
export class AccessModule { }
